import {
  TOGGLE_MODAL,
  SET_PAGE,
  SET_COLUMN_NAME,
  SET_FAVOURITE_TAB,
  SET_TRADATHON_LISTINGS_TAB,
  SET_TIME_IN_CHART,
  TOGGLE_VTRADING_MODAL,
  SET_VIRTUAL_TRADING_BUTTON,
  SET_ACTIVE_PORTFOLIO_PAGE,
  SET_ORDER_TYPE,
  SET_TRADATHON_RESULT_LISTING_TAB,
  SET_ACTIVE_ROOM_ID,
  TOGGLE_USER_ALERT_MODAL,
  TOGGLE_PUBLIC_CONTEST_MODAL,
} from "../types";
const parameterReducer = (state, action) => {
  switch (action.type) {
    case SET_ORDER_TYPE:
      return { ...state, placeOrderType: action.payload };
    case TOGGLE_MODAL:
      return { ...state, modal: !state.modal };
    case SET_PAGE:
      return { ...state, page: action.payload };
    case SET_COLUMN_NAME:
      return { ...state, columnName: action.payload };
    case SET_FAVOURITE_TAB:
      return { ...state, favouriteTab: action.payload };
    case SET_TRADATHON_LISTINGS_TAB:
      return { ...state, listingTab: action.payload };
    case SET_TIME_IN_CHART:
      return { ...state, timeInChart: action.payload };
    case TOGGLE_VTRADING_MODAL:
      return { ...state, vtradingModal: !state.vtradingModal };
    case SET_VIRTUAL_TRADING_BUTTON:
      return { ...state, vtButton: action.payload };
    case SET_ACTIVE_PORTFOLIO_PAGE:
      return { ...state, activePortfolio: action.payload };
    case SET_TRADATHON_RESULT_LISTING_TAB:
      return { ...state, tradathonResultListingTab: action.payload };
    case SET_ACTIVE_ROOM_ID:
      return { ...state, activeRoomId: action.payload };
    case TOGGLE_USER_ALERT_MODAL:
      return { ...state, userAlertModal: !state.userAlertModal };

    case TOGGLE_PUBLIC_CONTEST_MODAL:
      return { ...state, publicContestModal: !state.publicContestModal };
    default:
      return { ...state };
  }
};

export default parameterReducer;
